export type EnumLiteralsOf<T extends object> = T[keyof T];

export type AttoDeskStores = EnumLiteralsOf<typeof AttoDeskStores>;


export const Level = Object.freeze({
  1: "1" as const,
  2: "2" as const,
  3: "3" as const,
  4: "4" as const,
});

export const Grade = Object.freeze({
  A: "A" as const,
  B: "B" as const,
  C: "c" as const,
  D: "D" as const,
});

export const PaymentMethod = Object.freeze({
  PAD: "PAD" as const,
  DSSAB: "DSSAB" as const,
  Chq: "Chq" as const,
  EFT: "EFT" as const,
  PGT: "PGT" as const,
  Cash: "Cash" as const,
  ODSP: "ODSP" as const,
  LMR: "LMR" as const,
  BISNO: "BISNO" as const,
});

export const PaymentMethod2 = Object.freeze({
  DirectDeposit: "Direct Deposit" as const,
  Cheque: "Cheque" as const,
  Both: "Both" as const,
});

export const Relationship = Object.freeze({
  Son: "Son" as const,
  Daughter: "Daughter" as const,
  Grandson: "Grandson" as const,
  Granddaughter: "Granddaughter" as const,
  Spouse: "Spouse" as const,
  Sibling: "Sibling" as const,
  Friend: "Friend" as const,
  Other: "Other" as const,
});




export const PaymentStatus = Object.freeze({
  Pending: "pending" as const,
  Paid: "paid" as const,
});

export const PunchStatus = Object.freeze({
  punch_in: "punch_in" as const,
  punch_out: "punch_out" as const,
});

export const Privileges = Object.freeze({
  DashboardView: "Dashboard_View" as const,
  KitchenView: "Kitchen_View" as const,
  MainItemsView: "Main_Items_View" as const,
  ItemsView: "Items_View" as const,
  CategoriesView: "Categories_View" as const,
  StoreView: "Store_View" as const,
  SettingView: "Setting_View" as const,
  UserView: "User_View" as const,
  DepartmentView: "Department_View" as const,
  OrderList: "Order_List" as const,
  UserRoleView: "User_Role_View" as const,
  PrivilegeView: "Privilege_View" as const,
  OrderListManagerApproved: "Order_List_Manager_Approved" as const,
  BranchView: "Branch_View" as const,
  ThemeView: "Theme_View" as const,
  TaxView: "Tax_View" as const,
  OtherView: "Other_View" as const,
  PrinterView: "printer_View" as const,
  TagView: "tag_View" as const,
  BrandView: "brand_View" as const,


  PunchDetailsView: "PunchDetails_View" as const,
  ScheduleView: "Schedule_View" as const,
  PayrollView: "Payroll_View" as const,
  StaffView: "Staff_View" as const,
  PositionView: "Position_View" as const,
  ScheduleEdit: "Schedule_Edit" as const,
  GeneratePayroll: "Generate_Payroll" as const,

  ClientView: "Client_View" as const,
  InsuranceCompanyView: "Insurance_Company_View" as const,
  PoliciesView: "Policies_View" as const,
  CoverageView: "Coverage_View" as const,
  CompanyView: "Company_View" as const,
  LoopingView: "Looping_View" as const,
  ToDoView: "ToDo_View" as const,
  EmailView: "email_view" as const,
  NewslettersView: "newsletters_view" as const,
  ClientTypeView: "client_type_view" as const,
  WorkshopView: "workshop_view" as const,

});

export const UserRole = Object.freeze({
  Admin: 2 as const,
  User: 3 as const,
});

export const RoomType = Object.freeze({
  S: "S" as const,
  "1B": "1B" as const,
  "1B+": "1B+" as const,
  "2B": "2B" as const,
  "2B+": "2B+" as const,
});

export const OrderListStatus = Object.freeze({
  "OrderListCreated": "OrderListCreated" as const,
  "SentToManager": "SentToManager" as const,
  "ManagerApproved": "ManagerApproved" as const,
  "ManagerConfirmed": "ManagerConfirmed" as const,
  "Processed": "Processed" as const,
  "Completed": "Completed" as const,
  "Rejected": "Rejected" as const,
 
});

export const OrderListStatus2 = Object.freeze({
  "SentToManager": "SentToManager" as const,
  "ManagerApproved": "ManagerApproved" as const,
  "ManagerConfirmed": "ManagerConfirmed" as const,
  "Processed": "Processed" as const,
  "Completed": "Completed" as const,
  "Rejected": "Rejected" as const,
 
});

export const AttoDeskStores = Object.freeze({
  DEFAULT: "DEFAULT" as const,
  PRODUCT: "PRODUCT" as const,
  CATEGORY: "CATEGORY" as const,
  // SALEDETAILS: 'SALEDETAILS' as const,
});

export const RooleType = Object.freeze({
  FOOD: 1 as const,
  Beverages: 2 as const,
  Alcohol: 3 as const,
  Desserts: 4 as const,
});

export const KitchenPrinterType = Object.freeze({
  KDS: 1 as const,
  PVF: 2 as const,
  LMS: 3 as const,
  KDF: 4 as const,
});

export const SizeOfLevelType = Object.freeze({
  Bottle: 1 as const,
  Combo: 2 as const,
  Each: 3 as const,
  gal: 4 as const,
  gm: 5 as const,
  kg: 6 as const,
  Large: 7 as const,
  li: 8 as const,
  lb: 9 as const,
  Medium: 10 as const,
  oz: 11 as const,
  small: 12 as const,
});

export const LoopingConst = Object.freeze({
  Mobile: 1 as const,
  Computer: 2 as const,
});

export const ItemServiceChargeType = Object.freeze({
  None: 0 as const,
  Pay: 1 as const,
});

export const CategoryLevel = Object.freeze({
  Category: 0 as const,
  SubCategory: 1 as const,
  SubToSubCategory: 2 as const,
  SubToSubToSubCategory: 3 as const,
});

export const TableColumnTypeLevel = Object.freeze({
  string: "string" as const,
  integer: "integer" as const,
  boolean: "boolean" as const,
  // date: 3 as const,
});

export const TableColumnFieldLevel = Object.freeze({
  TextField: "TextField" as const,
  Switch: "Switch" as const,
  Selector: "Selector" as const,
  // MultipleSelector: "MultipleSelector" as const,
  // date: 3 as const,
});

export const CollectionType = Object.freeze({
  OneTime: "OneTime" as const,
  Monthly: "Monthly" as const,
  EveryTwoMonth: "EveryTwoMonth" as const,
  EveryThreeMonth: "EveryThreeMonth" as const,
  Custom: "Custom" as const,
});

export const ReminderMedianType = Object.freeze({
  sms: "sms" as const,
  email: "e-mail" as const,
});

export const TransactionCollectionDate = Object.freeze({
  1: "1" as const,
  2: "2" as const,
  3: "3" as const,
  4: "4" as const,
  5: "5" as const,
  6: "6" as const,
  7: "7" as const,
  8: "8" as const,
  9: "9" as const,
  10: "10" as const,
  11: "11" as const,
  12: "12" as const,
  13: "13" as const,
  14: "14" as const,
  15: "15" as const,
  16: "16" as const,
  17: "17" as const,
  18: "18" as const,
  19: "19" as const,
  20: "20" as const,
  21: "21" as const,
  22: "22" as const,
  23: "23" as const,
  24: "24" as const,
  25: "25" as const,
  26: "26" as const,
  27: "27" as const,
  28: "28" as const,
  29: "29" as const,
  30: "30" as const,
  31: "31" as const,
});

export const Gender = Object.freeze({
  Male: "0" as const,
  Female: "1" as const,
  Other: "2" as const,
});

export const BloodGroup = Object.freeze({
  A_Positive: "A+" as const,
  A_Negative: "A-" as const,
  B_Positive: "B+" as const,
  B_Negative: "B-" as const,
  AB_Positive: "AB+" as const,
  AB_Negative: "AB-" as const,
  O_Positive: "O+" as const,
  O_Negative: "O-" as const,
});

export const MaritalStatus = Object.freeze({
  Single: "0" as const,
  Married: "1" as const,
  Divorced: "2" as const,
  Widowed: "3" as const,
});

export const ClientStatus = Object.freeze({
  Active: "0" as const,
  Inactive: "1" as const,
  Pending: "2" as const,
  Closed: "3" as const,
});

export const ClientSource = Object.freeze({
  Referral: "0" as const,
  Website: "1" as const,
  WalkIn: "2" as const,
  CallCenter: "3" as const,
  Email: "4" as const,
  SocialMedia: "5" as const,
});

// export const RelationshipType = Object.freeze({
//   Mother: "Mother" as const,
//   Father: "Father" as const,
//   Son: "Son" as const,
//   Daughter: "Daughter" as const,
//   Spouse: "Spouse" as const,
//   Self: "Self" as const,
//   Brother : "Brother" as const,
//   Sister: "Sister" as const,
//   Other: "Other" as const,
// });

export const RelationshipType = Object.freeze({
  Husband: "Husband" as const,
  FatherInLaw: "Father -in -law" as const,
  Wife: "Wife" as const,
  Father: "Father" as const,
  Daughter: "Daughter" as const,
  Mother: "Mother" as const,
  Son: "Son" as const,
  PolicyOwner: "Policy owner" as const,
  CousinBrother: "Cousin brother" as const,
  Sister: "Sister" as const,
  Brother: "Brother" as const,
  MotherInLaw: "Mother -in -law" as const,
  SonInLaw: "Son-in - law" as const,
  DaughterInLaw: "Daughter - in - law" as const,
  Nephew: "Nephew" as const,
  Niece: "Niece" as const,
  GrandMother: "Grand mother" as const,
  GrandDaughter: "Grand Daughter" as const,
  BrotherInLaw: "Brother - in - law" as const,
  Friend: "Friend" as const,
  SisterInLaw: "Sister-in-law" as const,
  Uncle: "Uncle" as const,
  Aunt: "Aunt" as const,
  Self: "Self" as const,
  CousinSister: "Cousin sister" as const,
  GrandFather: "Grandfather" as const,
  GrandSon: "Grandson" as const,
  StepFather: "Stepfather" as const,
  StepMother: "Stepmother" as const,
  StepBrother: "Stepbrother" as const,
  StepSister: "Stepsister" as const,
  FosterChild: "Foster child" as const,
  LegalGuardian: "Legal guardian" as const,
  Partner: "Partner" as const,
  Other: "Other" as const,
});

export const ClientType = Object.freeze({
  InsuranceClient: "0" as const,
  RealstatesClient: "1" as const,
});

export const PolicyCollectionType = Object.freeze({
  OneTime: "OneTime" as const,
  Monthly: "Monthly" as const,
  EveryTwoMonths: "EveryTwoMonths" as const,
  EveryThreeMonths: "EveryThreeMonths" as const,
  Quarterly: "Quarterly" as const,      
  SemiAnnually: "SemiAnnually" as const,  
  Annually: "Annually" as const,          
  Custom: "Custom" as const,
});

export const DaysOfMonth = Object.freeze({
  "1st": "1st" as const,
  "2nd": "2nd" as const,
  "3rd": "3rd" as const,
  "4th": "4th" as const,
  "5th": "5th" as const,
  "6th": "6th" as const,
  "7th": "7th" as const,
  "8th": "8th" as const,
  "9th": "9th" as const,
  "10th": "10th" as const,
  "11th": "11th" as const,
  "12th": "12th" as const,
  "13th": "13th" as const,
  "14th": "14th" as const,
  "15th": "15th" as const,
  "16th": "16th" as const,
  "17th": "17th" as const,
  "18th": "18th" as const,
  "19th": "19th" as const,
  "20th": "20th" as const,
  "21st": "21st" as const,
  "22nd": "22nd" as const,
  "23rd": "23rd" as const,
  "24th": "24th" as const,
  "25th": "25th" as const,
  "26th": "26th" as const,
  "27th": "27th" as const,
  "28th": "28th" as const,
  "29th": "29th" as const,
  "30th": "30th" as const,
  "31st": "31st" as const,
});

export const ReminderBeforeOption = Object.freeze({
  "5Min": "5 Min" as const,
  "10Min": "10 Min" as const,
  "15Min": "15 Min" as const,
  "30Min": "30 Min" as const,
  "1Hour": "1 Hour" as const,
  "2Hour": "2 Hours" as const,
  "3Hour": "3 Hours" as const,
  "6Hour": "6 Hours" as const,
  "12Hour": "12 Hours" as const,
  "1Day": "1 Day" as const,
  "2Day": "2 Days" as const,
  "3Day": "3 Days" as const,
  "1Week": "1 Week" as const
});

export const ReminderPolicyBeforeOption = Object.freeze({
  "1Day": "1 Day" as const,
  "2Day": "2 Days" as const,
  "3Day": "3 Days" as const,
  "5Day": "5 Days" as const,
  "1Week": "1 Week" as const,
  "2Week": "2 Weeks" as const,
  "3Week": "3 Weeks" as const,
  "1Month": "1 Month" as const,
  "2Month": "2 Months" as const,
  "3Month": "3 Months" as const
});

export const BenificeryType = Object.freeze({
  "Illness": "Illness" as const,
  "Death": "Death" as const,
  "Maturity": "Maturity" as const,
  "Disability": "Disability" as const,
  "Accident": "Accident" as const,
  "Terminal Illness": "Terminal Illness" as const,
});

export const emailNotification = Object.freeze({
  "Admin": "Admin" as const,
  "Meeting Notification": "Meeting Notification" as const,
  "Newsletters Notification": "Newsletters Notification" as const,

});

export const widthofReactQuill = Object.freeze({
  "200px": "200px" as const,
  "300px": "300px" as const,
  "400px": "400px" as const,
});

export const workshopStatus = Object.freeze({
  "Pending": "Pending" as const,
  "Confirm": "Confirm" as const,
  "Completed": "Completed" as const,
  "Cancel": "Cancel" as const,
});


